import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <AboutSection />
        <RankingSection />
        <ContactSection />
        <IndexSection />
        <UpdatesSection />
        <FAQSection />
        <CardsSection />
        <CommentsSection />
        <AppSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}